import React, { useEffect, useState } from "react"
import { useDispatch } from "react-redux"
import useTaskListSettings from "hooks/useTaskListSettings"
import { getTasks } from "reduxSlices/taskTableSlice"
import withReduxProvider from "shared/withReduxProvider"
import Sidebar from "./Sidebar"
import Content from "./Content"

const TaskList = () => {
  const dispatch = useDispatch()

  useTaskListSettings()

  const [hiddenSidebar, setHiddenSidebar] = useState(true)
  const toggleSidebar = () => setHiddenSidebar(!hiddenSidebar)

  useEffect(() => {
    dispatch(getTasks())
  }, [dispatch])

  return (
    <>
      <Sidebar hiddenSidebar={hiddenSidebar} />
      <Content
        hiddenSidebar={hiddenSidebar}
        toggleSidebar={toggleSidebar}
      />
      <div />
    </>
  )
}

export default withReduxProvider(TaskList)
